/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import './more-menu.css';
import { MORE_MENU_SCREEN, COMMON, SYNC_SERVICE, ALL_ROUTES } from '../../global/Constants';
//import { MORE_MENU_TYPES } from '../../global/Enum';
import { withRouter } from 'react-router-dom';
import Select from 'react-select';
import ApiServices from '../../providers/ApiServices';
import Utilities from '../../global/Utilities';
import SyncServices from '../../providers/SyncServices';
import { toast } from 'react-toastify';

class MyProfilePage extends Component {

    constructor(props) {
        super(props)

        this.state = {
            selectedState: null,
            selectedDistrict: null,
            selectedTehsil: null,
            selectedVillage: null,
            userData: null,
            profileImage: null,
            allStatesData: [],
            allDistrictsData: [],
            allTehsilsData: [],
            allVillagesData: [],
            fields: {
                name: "",
                mobile: "",
                email: "",
                employeeId: "",
                address: "",
                pinCode: ""
            },
        }
    }

    componentDidMount() {
        if (Utilities.checkLogin()) {
            const { userData } = this.state;
            if (userData === null) {
                this.getAllStates();
                this.getUserById();
            }

        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE);
        }
    }

    componentWillReceiveProps(newProps) {
        const { profileImage } = this.props;
        if (profileImage) {
            this.setState({
                profileImage
            })
        }
    }

    _getFieldValue(fieldName, defaultValue) {
        const { fields } = this.state;
        let value = fields[fieldName];
        if (value === null || typeof value === "undefined") {
            value = defaultValue;
        }
        return value;
    }

    handleOnMenuClose = () => {
        this.updateNextButton()
    }

    _handleValueChange = (field, e) => {
        let fields = this.state.fields;
        const value = e.target.value.replaceAll(/[^a-zA-Z0-9 ]/g, "");
        if (value) {
            fields[field] = value;
        } else {
            fields[field] = "";
        }
        this.setState({ fields });
        this.updateNextButton();
    };

    updateNextButton = () => {
        const name = this._getFieldValue("name", "");
        const { selectedTehsil } = this.state;
        document.getElementById("submit").disabled = !(name !== "" && selectedTehsil);
    }

    handleSubmitClick = (e) => {
        e.preventDefault();
        this.editUser();
    }

    editUser = () => {
        this.props.loaderCallback(true);
        const { selectedState, selectedDistrict, selectedTehsil, selectedVillage, fields } = this.state;

        var body = JSON.stringify({
            name: fields.name,
            state_id: selectedState?.value,
            district_id: selectedDistrict?.value,
            tehsil_id: selectedTehsil?.value,
            village_id: selectedVillage?.value,
            address: fields.address,
            pinCode: fields.pinCode
        });
        try {
            ApiServices.editUser(body).then(response => {
                var status = response.success;
                if (status) {
                    toast.success(response.message);
                    this.props._sendToParent(false)
                    this.props.loaderCallback(false);
                } else {
                    this.props.loaderCallback(false);
                    toast.error(response.message);
                }
            }).catch(error => {
                this.props.loaderCallback(false);
            });
        } catch (error) {
            this.props.loaderCallback(false);
        }
    }

    getUserById = () => {
        if (Utilities.isNetworkConnected()) {
            //const session = AuthService.getSession();
            this.props.loaderCallback(true);
            // var body = JSON.stringify({
            //     get_by: "employee_id",
            //     get_by_value: session?.user.employee_id,
            //     lastSync: ""
            // });
            try {
                ApiServices.getUserById().then(response => {
                    var status = response.success;
                    if (status) {
                        const data = response.data[0];
                        this.setState({
                            userData: data,
                            profileImage: data.profile_pic,
                            fields: {
                                name: data.name,
                                mobile: data.phone,
                                email: data.email,
                                employeeId: data.employee_id,
                                address: data?.address,
                                pinCode: data?.pin_code
                            },
                            selectedState: {
                                value: data.user_location.state_id,
                                label: data.user_location.state_name
                            },
                            selectedDistrict: {
                                value: data.user_location.district_id,
                                label: data.user_location.district_name
                            },
                            selectedTehsil: {
                                value: data.user_location.tehsil_id,
                                label: data.user_location.tehsil_name
                            },
                            selectedVillage: {
                                value: data.user_location.village_id,
                                label: data.user_location.village_name
                            }
                        })
                        this.props.loaderCallback(false);
                    } else {
                        this.props.loaderCallback(false);
                        if (response.message === COMMON.TOKEN_EXPIRED) {
                            Utilities.tokenExpiredRedirectToLogin();
                        }
                    }
                }).catch(error => {
                    this.props.loaderCallback(false);
                });
            } catch (error) {
                this.props.loaderCallback(false);
            }
        }
    }

    getAllStates = () => {

        SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_STATE, SYNC_SERVICE.MASTER_TABLE).then(data => {
            if (data && data !== undefined && data.length > 0) {
                this.setState({
                    allStatesData: data.map(({ state_id: value, state_name: label, ...rest }) => ({ value, label, ...rest }))
                });
            }
        });
    }

    getAllDistricts = (selectedState) => {

        SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_DISTRICT, SYNC_SERVICE.MASTER_TABLE).then(data => {

            if (data && data !== undefined && data.length > 0) {

                var filterData = [];
                for (var i = 0; i < data.length; i++) {
                    if (data[i].state_id === selectedState.value) {
                        filterData.push(data[i]);
                    }
                }

                this.setState({
                    allDistrictsData: filterData.map(({ district_id: value, district_name: label, ...rest }) => ({ value, label, ...rest }))
                });
            }
        });
    }

    getAllTehsils = (selectedDistrict) => {

        SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_TEHSIL, SYNC_SERVICE.MASTER_TABLE).then(data => {
            if (data && data !== undefined && data.length > 0) {
                var filterData = [];
                for (var i = 0; i < data.length; i++) {
                    if (data[i].district_id === selectedDistrict.value) {
                        filterData.push(data[i]);
                    }
                }
                this.setState({
                    allTehsilsData: filterData.map(({ tehsil_id: value, tehsil_name: label, ...rest }) => ({ value, label, ...rest }))
                });
            }
        });
    }

    getAllVillageById = (selectedTehsil) => {

        SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_VILLAGE, SYNC_SERVICE.MASTER_TABLE).then(data => {
            if (data && data !== undefined && data.length > 0) {
                var filterData = [];

                for (var i = 0; i < data.length; i++) {
                    if (data[i].tehsil_id === selectedTehsil.value) {
                        filterData.push(data[i]);
                    }
                }
                this.setState({
                    allVillagesData: filterData.map(({ village_id: value, village_name: label, ...rest }) => ({ value, label, ...rest }))
                });
            }
        });
    }

    handleStateChange = selectedState => {
        if (selectedState === null) {
            this.setState({
                selectedState: null,
                selectedDistrict: null,
                selectedTehsil: null,
                selectedVillage: null,
            });
        } else {
            this.setState({
                selectedState, selectedDistrict: null,
                selectedTehsil: null,
                selectedVillage: null, allDistrictsData: [], allTehsilsData: [], allVillagesData: []
            });
            this.getAllDistricts(selectedState);
        }
        this.updateNextButton()
    };

    handleDistrictChange = selectedDistrict => {
        if (selectedDistrict === null) {
            this.setState({
                selectedDistrict: null,
                selectedTehsil: null,
                selectedVillage: null,
            });
        } else {
            this.setState({
                selectedDistrict,
                selectedTehsil: null,
                selectedVillage: null,
                allTehsilsData: [],
                allVillagesData: []
            });
            this.getAllTehsils(selectedDistrict);
        }
        this.updateNextButton()
    };

    handleTehsilChange = selectedTehsil => {
        if (selectedTehsil === null) {
            this.setState({
                selectedTehsil: null,
                selectedVillage: null,
            }, () => {
                this.updateNextButton();
            });
        } else {
            this.setState({ selectedTehsil, selectedVillage: null, allVillagesData: [] }, () => {
                this.updateNextButton();
            });
            this.getAllVillageById(selectedTehsil);
        }
    };

    handleGalleryCLick = () => {
        document.getElementById('profileFile1').click();
    }

    handleVillageChange = selectedVillage => {
        this.setState({ selectedVillage });
    };

    // On file select (from the pop up)
    onFileChange = event => {

        if (event.target.files && event.target.files[0]) {
            let reader = new FileReader();
            reader.onload = (e) => {
                this.setState({
                    profileImage: e.target.result
                })
                this.uploadProfileImage(event.target.files[0]);
                event.target.value = null;
            };
            reader.readAsDataURL(event.target.files[0]);
        }
    };

    uploadProfileImage(file) {
        const formData = new FormData();
        formData.append("image", file);
        try {
            ApiServices.updateUserImage(formData)
                .then(response => {
                    Utilities.LogPrint("API_DATA: ---->", response);
                    this.setState({ isLoading: false });
                    if (response.success) {
                    } else {
                        alert(response.message);
                    }
                }).catch(error => {
                    this.setState({ isLoading: false });
                });
        } catch (error) {
            this.setState({ isLoading: false });
        }
    }


    render() {

        const { isActive } = this.props;
        const name = this._getFieldValue("name", "");
        const mobile = this._getFieldValue("mobile", "");
        const email = this._getFieldValue("email", "");
        const employeeId = this._getFieldValue("employeeId", "");
        const pinCode = this._getFieldValue("pinCode", "");
        const address = this._getFieldValue("address", "");

        const { allStatesData, allDistrictsData, allTehsilsData, allVillagesData, profileImage, selectedState, selectedDistrict, selectedTehsil, selectedVillage } = this.state;

        return (
            <div id="myProfile" className={isActive ? "more-menu-body" : "more-menu-body d-none"}>
                <form action="">
                    <div className="row">
                        <div className="col-12">
                            <h5 className="title">{MORE_MENU_SCREEN.INFORMATION}</h5>
                            <h6 className="my-profile">{MORE_MENU_SCREEN.MY_PROFILE}</h6>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 text-center">
                            <div className="edit-profile-img mb-4 mt-2">
                                <img src={profileImage ? profileImage : "../assets/images/default-user.png"} alt="" />

                                {/* <input type="file" className="customic ic-edit-profile" /> */}
                                <input className="d-none" accept="image/*" id="profileFile1" type="file" onChange={this.onFileChange} />
                                <i className="customic ic-edit-profile" onClick={this.handleGalleryCLick}></i>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-md-6">
                            <div className="form-group">
                                <label className="font-weight-medium">{COMMON.NAME}</label>
                                <input type="text" className="form-control" placeholder="Enter Name" onChange={this._handleValueChange.bind(this, "name")} value={name} />
                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="form-group">
                                <label className="font-weight-medium">{COMMON.EMAIL}</label>
                                <input type="email" className="form-control" value={email} disabled={true} placeholder="Enter Email ID" />
                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="form-group">
                                <label className="font-weight-medium">{COMMON.MOBILE_NUMBER}</label>
                                <input type="text" className="form-control" value={mobile} disabled={true} placeholder="9067312828" />
                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="form-group">
                                <label className="font-weight-medium">{COMMON.EMPLOYEE_ID}</label>
                                <input type="text" className="form-control" value={employeeId} disabled={true} placeholder="001" />
                            </div>
                        </div>
                        {/* <div className="col-12 col-md-6">
                            <div className="form-group">
                                <label className="font-weight-medium">{COMMON.HEADQUARTERS}</label>
                                <input type="text" className="form-control" disabled={true} placeholder="Gurugram" />
                            </div>
                        </div> */}
                    </div>

                    <div className="row">
                        <hr className="w-100 bdr-color-gray" />
                    </div>

                    <div className="row">
                        <div className="col-12 col-md-12">
                            <div className="form-group">
                                <h5 className="title d-block">{COMMON.POSTAL_ADDRESS}</h5>
                                <div className="row">
                                    <div className="col-md-12 col-12">
                                        <input type="text" className="form-control mb-3" value={address} onChange={this._handleValueChange.bind(this, "address")} placeholder="Enter Address" />
                                    </div>
                                    <div className="col-md-6 col-12">
                                        <Select className="mb-3 max-w-360"
                                            value={selectedState}
                                            onChange={this.handleStateChange}
                                            options={allStatesData}
                                            onMenuClose={this.handleOnMenuClose}
                                            placeholder="Select State"
                                            isClearable={true}
                                        />
                                    </div>
                                    <div className="col-md-6 col-12">
                                        <Select className="mb-3 max-w-360"
                                            value={selectedDistrict}
                                            onChange={this.handleDistrictChange}
                                            options={allDistrictsData}
                                            placeholder="Select District"
                                            isClearable={true}
                                            onMenuClose={this.handleOnMenuClose}
                                            isDisabled={selectedState === null ? true : false}
                                        />
                                    </div>

                                    <div className="col-md-6 col-12">
                                        <Select className="mb-3 max-w-360"
                                            value={selectedTehsil}
                                            onChange={this.handleTehsilChange}
                                            options={allTehsilsData}
                                            placeholder="Select Tehsil"
                                            isClearable={true}
                                            onMenuClose={this.handleOnMenuClose}
                                            isDisabled={selectedDistrict === null ? true : false}
                                        />
                                    </div>

                                    <div className="col-md-6 col-12">
                                        <Select className="mb-3 max-w-360"
                                            value={selectedVillage}
                                            onChange={this.handleVillageChange}
                                            options={allVillagesData}
                                            placeholder="Select Village"
                                            isClearable={true}
                                            onMenuClose={this.handleOnMenuClose}
                                            isDisabled={selectedTehsil === null ? true : false}
                                        />
                                    </div>

                                    <div className="col-md-6 col-12">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={pinCode}
                                            maxLength="6"
                                            onChange={this._handleValueChange.bind(this, "pinCode")}
                                            placeholder="Enter Zipcode" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 d-flex button-grp-bottom">
                            <button className="btn btn-secondary w-50 mr-2" onClick={() => { this.props._sendToParent(false) }}>{COMMON.BACK}</button>
                            <button id={"submit"} className="btn btn-primary w-50" onClick={this.handleSubmitClick} >{COMMON.SUBMIT_CAP}</button>
                        </div>
                    </div>
                </form>

            </div>
        );
    }
}

export default withRouter(MyProfilePage)